import { apiFetch } from './client';

// Bare fetchers only — no hooks. These are called from the pre-prompt / service-worker
// registration flow (a later task), not rendered directly against a TanStack Query cache: the
// browser's own PushManager subscription state is the source of truth, not something this app
// re-fetches and displays like a normal query.

export const getVapidKey = () =>
  apiFetch<{ publicKey: string }>('/push/vapid-key').then((r) => r.publicKey);

export type PushSubscriptionInput = {
  endpoint: string;
  p256dh: string;
  auth: string;
  tzOffsetMin: number;
};

export const postSubscription = (sub: PushSubscriptionInput) =>
  apiFetch<void>('/push/subscriptions', { method: 'POST', body: JSON.stringify(sub) });

export const deleteSubscription = (endpoint: string) =>
  apiFetch<void>('/push/subscriptions', { method: 'DELETE', body: JSON.stringify({ endpoint }) });

